import React from 'react';
import { ChartBarIcon, UserGroupIcon, MapIcon, CurrencyDollarIcon } from '@heroicons/react/24/outline';

const stats = [
  { name: 'Total Users', value: '2,543', icon: UserGroupIcon, change: '+12%', changeType: 'increase' },
  { name: 'Active Jobs', value: '156', icon: MapIcon, change: '+8%', changeType: 'increase' },
  { name: 'Revenue', value: '$12,345', icon: CurrencyDollarIcon, change: '+23%', changeType: 'increase' },
  { name: 'Analytics', value: '98%', icon: ChartBarIcon, change: '+4%', changeType: 'increase' },
];

const Dashboard: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-bodytext dark:text-white">Dashboard</h1>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat) => (
          <div
            key={stat.name}
            className="bg-white dark:bg-dark rounded-lg shadow p-6 border border-border dark:border-darkborder"
          >
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <stat.icon className="h-6 w-6 text-primary" aria-hidden="true" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-bodytext dark:text-white">{stat.name}</p>
                <p className="text-2xl font-semibold text-bodytext dark:text-white">{stat.value}</p>
              </div>
            </div>
            <div className="mt-4">
              <span
                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                  stat.changeType === 'increase'
                    ? 'bg-success/10 text-success'
                    : 'bg-error/10 text-error'
                }`}
              >
                {stat.change}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Recent Activity */}
      <div className="bg-white dark:bg-dark rounded-lg shadow border border-border dark:border-darkborder">
        <div className="px-6 py-4 border-b border-border dark:border-darkborder">
          <h2 className="text-lg font-medium text-bodytext dark:text-white">Recent Activity</h2>
        </div>
        <div className="p-6">
          <p className="text-bodytext dark:text-white">No recent activity</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 